var map = {
	"./basketball-active.webp": 1475,
	"./basketball.webp": 1476,
	"./bg.webp": 1477,
	"./football-active.webp": 1478,
	"./football.webp": 1479,
	"./games-active.webp": 1480,
	"./games.webp": 1481,
	"./information.webp": 1482,
	"./live-streaming-cover.webp": 1483,
	"./lv-active-bg.webp": 1484,
	"./video-bg.webp": 1485,
	"./video-icon.webp": 1486,
	"./vs.webp": 1487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 461;